// default viewport center US
type Viewport = {
  center: google.maps.LatLng
  zoom: number
}
export const DEFAULT_VIEWPORT: Viewport = {
  center: ({ lat: 38.6233822, lng: -90.4902562 } as unknown) as google.maps.LatLng,
  zoom: 10,
}
